module.exports = __webpack_public_path__ + "static/media/send.562a1104.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/send.svg
// module id = 462
// module chunks = 0